import { ProductFeature } from '@/api/generated/api.enum';
import { useBillingState } from '@/composables/billing/useBillingState';
import { useCheckoutOfferSource } from '@/composables/billing/useCheckoutOfferSource';
import BillingCheckoutDialog from '@/core/dialogs/billing-checkout/BillingCheckoutDialog.vue';
import { useDialog } from '@/core/dialogsystem/useDialog';

export function useAttachmentFeature() {
  const { hasFeature } = useBillingState();
  const { getFeatureGateOfferSource } = useCheckoutOfferSource();
  const checkout = useDialog({ component: BillingCheckoutDialog, props: {} });

  const requestAttachmentAccess = (): boolean => {
    if (hasFeature(ProductFeature.attachments)) return true;
    checkout.show({
      feature: ProductFeature.attachments,
      offerSource: getFeatureGateOfferSource(ProductFeature.attachments),
    });
    return false;
  };

  return { requestAttachmentAccess };
}
